import { render, staticRenderFns } from "./ColorWheelIcon.vue?vue&type=template&id=413c0966&"
import script from "./ColorWheelIcon.vue?vue&type=script&lang=js&"
export * from "./ColorWheelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports